/*
 * The single logout entry point.
 *
 * Six different places used to sign the user out and each did something
 * slightly different: some cleared sessionStorage, some reloaded the page, only
 * one reset the RTK Query cache. That last omission is why a second user
 * signing in on the same terminal briefly saw the previous user's tables,
 * carts and orders - the cached responses were still in the store.
 */

import { logout } from "../Slices/authSlice";
import { apiSlice } from "../Slices/apiSlice";

export const signOut = () => (dispatch) => {
  // Order matters: `logout` wipes browser storage (including the access token)
  // before the API cache is dropped, so nothing can refetch with the old token.
  dispatch(logout());
  dispatch(apiSlice.util.resetApiState());
};
